import React from "react";
import { X, AlertTriangle } from "lucide-react";
import { DISCLAIMER_FULL } from "@/lib/disclaimer";

/** Read-only viewer for the clinical disclaimer (no checkboxes / no acknowledgment). */
export default function DisclaimerViewer({ onClose }) {
  return (
    <div
      className="fixed inset-0 z-[60] bg-black/40 backdrop-blur-sm flex items-center justify-center p-4"
      onClick={onClose}
      data-testid="disclaimer-viewer"
    >
      <div
        className="bg-white w-[95vw] sm:w-full max-w-3xl rounded-2xl shadow-2xl overflow-hidden mobile-fullwidth-modal"
        role="dialog"
        aria-modal="true"
        onClick={(e) => e.stopPropagation()}
      >
        <div className="px-6 py-4 bg-amber-50 border-b border-amber-200 flex items-center justify-between">
          <div className="flex items-center gap-3">
            <AlertTriangle className="w-5 h-5 text-amber-700" />
            <div className="font-semibold text-amber-900 text-sm">Clinical Decision Support Disclaimer</div>
          </div>
          <button
            onClick={onClose}
            className="p-1.5 hover:bg-amber-100 rounded text-amber-900"
            data-testid="disclaimer-viewer-close"
          >
            <X className="w-4 h-4" />
          </button>
        </div>
        <div className="px-6 py-5 max-h-[65vh] overflow-y-auto">
          <pre className="whitespace-pre-wrap font-sans text-[13px] leading-relaxed text-brand-text">
            {DISCLAIMER_FULL}
          </pre>
        </div>
        <div className="px-6 py-3 border-t border-brand text-[11px] text-brand-muted text-center">
          This view is read-only. Your acknowledgment from first login is on file and remains valid.
        </div>
      </div>
    </div>
  );
}
